<template>
  <div class="buttonlist-area">
    <div v-for="item in questionTypes" :key="item.id" class="group-container">
      <div class="group-item-label">{{ item.name }}</div>
      <div class="radio-group">
        <div
          v-for="itemx in item.children"
          :key="itemx.id"
          class="radio-group-button"
          :class="{active: selectedValue && selectedValue === itemx.id}"
          @click="buttonClick(itemx.id,itemx)"
        >
          <div class="radio-group-button-label"><span>{{ itemx.name }}</span></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'QuestionRadioButtonGroup',
  data() {
    return {
      listArr: [],
      selectedValue: ''
    }
  },
  props: {
    // 默认值
    defaultVale: {
      type: String,
      default: ''
    },
    // 支持多选
    mutiple: {
      type: Boolean,
      default: false
    },
    // 选择的问题
    questionTypes: {
      type: Array,
      default: () => []
    },
    // 订单ID
    orderId: {
      type: String,
      default: ''
    }
  },
  watch: {
    questionTypes(curVal, _newVal) {
      this.listArr = curVal
    }
  },
  created() {
    this.listArr = this.questionTypes
  },
  methods: {
    // 某个按钮选中
    buttonClick(val, item) {
      this.selectedValue = val
      this.$emit('selectQueType', item)
    }
  }
}
</script>

<style lang="less" scoped>
@import './index.less';
</style>
